
export const CLOSE_INFORMATION_MODAL = 'CLOSE_INFORMATION_MODAL';
export const closeInformationModal = () => ({type: CLOSE_INFORMATION_MODAL});

export const OPEN_INFORMATION_MODAL = 'OPEN_INFORMATION_MODAL';
export const openInformationModal = (text) => ({
    type: OPEN_INFORMATION_MODAL,
    payload: {text}
});



// WEBPACK FOOTER //
// ./src/components/information-modal/InformationModalActions.js